module.exports = __webpack_public_path__ + "static/P7-16eaa8a69eaef10ddabe5e997d1298bd.jpg";